function injectStyle (ssrContext) {
  require("!!../../../../node_modules/_extract-text-webpack-plugin@3.0.2@extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/_vue-loader@13.5.0@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-50752daa\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../../node_modules/_vue-loader@13.5.0@vue-loader/lib/selector?type=styles&index=0!./TagsView.vue")
  require("!!../../../../node_modules/_extract-text-webpack-plugin@3.0.2@extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/_vue-loader@13.5.0@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-50752daa\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../../node_modules/_vue-loader@13.5.0@vue-loader/lib/selector?type=styles&index=1!./TagsView.vue")
}
var normalizeComponent = require("!../../../../node_modules/_vue-loader@13.5.0@vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../../../../node_modules/_vue-loader@13.5.0@vue-loader/lib/selector?type=script&index=0!./TagsView.vue"
/* template */
import __vue_template__ from "!!../../../../node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-50752daa\",\"hasScoped\":true,\"buble\":{\"transforms\":{}}}!../../../../node_modules/_vue-loader@13.5.0@vue-loader/lib/selector?type=template&index=0!./TagsView.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50752daa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/layout/components/TagsView.vue
// module id = Vg/Y
// module chunks = 307